import {Base} from "@/api/Base"

export class AttendanceDelete extends Base {
    path = "attendance/delete"
}